import type { ElementKey } from '~/types/game'

export interface ElementInfo {
  key: ElementKey
  label: string
  /** Legacy text emoji — only for contexts that can't render an <img>
   * (composed strings, tooltips). Visible UI should use <ElementIcon>
   * with `image` instead (v1.06). */
  icon: string
  /** Canonical element icon in public/elements/. Version the filename
   * whenever the art changes (v1.15's -v2): the paths are cached hard
   * by browsers, and a same-name swap never reaches players. */
  image: string
  color: string
}

export const ELEMENT_INFO: Record<ElementKey, ElementInfo> = {
  fire: { key: 'fire', label: 'Fire', icon: '🔥', image: '/elements/fire-v4.png', color: '#f4511e' },
  water: { key: 'water', label: 'Water', icon: '💧', image: '/elements/water-v4.png', color: '#2f80ed' },
  grass: { key: 'grass', label: 'Grass', icon: '🌿', image: '/elements/grass-v4.png', color: '#43a047' },
  lightning: { key: 'lightning', label: 'Lightning', icon: '⚡', image: '/elements/lightning-v4.png', color: '#f2a900' },
  earth: { key: 'earth', label: 'Earth', icon: '🪨', image: '/elements/earth-v6.png', color: '#8d6e4c' },
}
